import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import translations from 'ui/src/locales'

const i18nConfig = {
  resources: translations,
  fallbackLng: 'en-US',
  defaultNS: 'translations',
  interpolation: {
    escapeValue: false, // React already handles escaping
  },
  detection: {
    order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
    lookupQuerystring: 'lang',
    caches: ['cookie'],
  },
}

i18n.use(LanguageDetector).use(initReactI18next).init(i18nConfig)

export { i18n }

export default i18n
